import { menu } from '../config'; // axios instance
import { handleError } from '../helpers/handles';
import authHeader from '../helpers/authHeader';

const getAll = () => {
  const config = {
    method: 'GET',
    url: '/v1/tags',
    headers: authHeader(),
  };

  return menu.http(config).catch(handleError);
};

const getOne = (id) => {
  const config = {
    method: 'GET',
    url: `/v1/tags/${id}`,
    headers: authHeader(),
  };

  return menu.http(config).catch(handleError);
};

const create = (data) => {
  const config = {
    method: 'POST',
    url: `/v1/tags`,
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    data,
  };

  return menu.http(config).catch(handleError);
};

const update = (id, data) => {
  const config = {
    method: 'PUT',
    url: `/v1/tags/${id}`,
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    data,
  };

  return menu.http(config).catch(handleError);
};

const remove = (id) => {
  const config = {
    method: 'DELETE',
    url: `/v1/tags/${id}`,
    headers: authHeader(),
  };

  return menu.http(config).catch(handleError);
};

export default {
  getAll,
  getOne,
  create,
  update,
  remove,
};
